<template>
    <div class="my-path-edit-modal">

        <!-- edit button -->
        <b-btn size="sm" class="btn-edit btn-icon" variant="default"
               @click.stop="showModal()">
            <shs-icon name="pencil"></shs-icon>
        </b-btn>

        <!-- modal -->
        <b-modal :id="`modal_${field}`"
                 no-close-on-backdrop
                 body-class="light-bg"
                 :title="title">

            <template v-slot:modal-header>
                <h5>{{ title }}</h5>
            </template>

            <b-alert variant="info" show>
                {{ infoText }}
            </b-alert>
            <b-form-group>
                <b-form-textarea v-model="path[field]"></b-form-textarea>
            </b-form-group>

            <template v-slot:modal-footer>
                <div class="float-right">
                    <b-btn class="btn-cancel ml-3 mr-2"
                           @click="cancel()">
                        <template v-if="$mq == 'sm'">
                            <b-icon icon="x"></b-icon>
                        </template>
                        <template v-else>
                            {{ $i18n.gt('LABEL_CANCEL') }}
                        </template>
                    </b-btn>

                    <b-btn variant="primary"
                           @click="ok()">
                        <span v-if="$mq == 'sm'">
                            <b-icon icon="check"></b-icon>
                        </span>
                        <span v-else>
                            {{ $i18n.gt('LABEL_SAVE') }}
                        </span>
                    </b-btn>
                </div>
            </template>

        </b-modal>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * Button and modal to edit fields on the user's wellness Path
 */

export default Vue.extend({
    name: 'MyPathEditModal',
    props: {
        title: String,
        infoText: String,
        path: Object,
        field: String
    },
    data() {
        return {
            originalValue: null
        }
    },
    methods: {
        showModal() {
            this.originalValue = this.path[this.field]
            this.$bvModal.show(`modal_${this.field}`)
        },
        cancel() {
            this.$bvModal.hide(`modal_${this.field}`)
            this.path[this.field] = this.originalValue
        },
        ok() {
            this.$bvModal.hide(`modal_${this.field}`)
            this.$store.dispatch('savePatientParticipant')
        },
    },
})
</script>
